import * as React from 'react'

export function Logo(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 78.25 10.62"
            {...props}
        >
            <title>{'\n        DeepMay\n    '}</title>
            <g data-name="Layer 1">
                <path d="M3.53 0H0l2.15 2.61h.92l-.61 3.44-1.03.88-.65 3.69 2.91-2.48.6.73.39-2.23.01-.06.75-4.26h4.32l-.22 1.25-3.62 3.07H4.74l1.84 2.23 5.12-4.34.4-2.3L10.26 0H3.53zM75.18 2.61 78.25 0h-4.1l-.3 1.71-1.3-1.57-.8 4.57h-1.24l-2.54-3.07.29-1.64h-2.32l-.46 2.6 3.66 4.44v-.01h2.2l-.18 1.01.76.93h.61l1.36 1.65.65-3.69-.71-.85.62-3.47h.73zM19.64 0h-6.55l-.79 4.52L16 9h4.53v-.08l-.83-1 .55-3.1-2.18 1.82h-.75L17 6.26l4.58-3.89Zm-4 4.62-.87-1.05.23-1.24h3.35ZM29.73 4.82l-2.14 1.82h-.7l-.31-.38 4.61-3.92L29.26 0h-6.6l-.8 4.52L25.51 9H30l-.86-1Zm-4.51-.2-.86-1.05.22-1.24h3.35ZM40.84 2.23 39 0h-6.77l-1.58 8.97h2.32l.07-.41.31-1.75.41-2.32v-.03l.38-2.13h3.4L35 4.49h-1.22l1.85 2.25 5.19-4.41.02-.1z" />
                <path d="M53.03 0h-4.52l-.39 2.19L46.31 0h-6.48l-.05.04 1.65 2-.8 4.53 1.91 2.32.55-3.12.92 1.1.65-3.68-.71-.86h1l2.59 3.14-.16.92-1.56 1.33 2.39 2.9.29-1.65h.75l1.17-6.64h1.24L54.2 5.4l-.22 1.21 1.91 2.32.8-4.49L53.03 0zM62.61 0h-4.54l-1.36 7.72L57.77 9h1l.08-.44.39-2.2.34-1.9 1.91 2.33h2L63.32 8l.8 1h1.36l.8-4.54L62.62 0Zm-3 4.45L60 2.33h.9l1.75 2.13Z" />
            </g>
        </svg>
    )
}

export function Initials(props) {
    return (
        <svg
            width={72}
            height={28}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#a)">
                <path d="M26.21 0H0l5.478 6.66h2.363l-1.575 8.808-2.614 2.255L1.97 27.14l7.448-6.337 1.54 1.861 1.002-5.693v-.143l1.933-10.884H24.92l-.537 3.186-9.273 7.841h-3.008l4.69 5.693 13.105-11.1L30.9 5.694 26.21 0Z" />
                <path d="M62.264 0H50.7l-.966 5.586L45.114 0H28.536l-.107.107 4.19 5.12-2.042 11.565 4.905 5.908 1.397-7.948 2.327 2.792 1.647-9.38-1.79-2.22h2.542l6.66 8.02-.43 2.363-4.01 3.401 6.123 7.412.716-4.225h1.933L55.57 5.944h3.187l6.48 7.84L64.7 16.9l4.87 5.908 2.04-11.458L62.265 0Z" />
            </g>
            <defs>
                <clipPath id="a">
                    <path d="M0 0h71.61v27.14H0V0Z" />
                </clipPath>
            </defs>
        </svg>
    )
}

export function Instagram(props) {
    return (
        <svg
            width="100%"
            height="100%"
            viewBox="0 0 256 256"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid"
            {...props}
        >
            <path d="M128 23.064c34.177 0 38.225.13 51.722.745 12.48.57 19.258 2.655 23.769 4.408 5.974 2.322 10.238 5.096 14.717 9.575 4.48 4.479 7.253 8.743 9.575 14.717 1.753 4.511 3.838 11.289 4.408 23.768.615 13.498.745 17.546.745 51.723 0 34.178-.13 38.226-.745 51.723-.57 12.48-2.655 19.257-4.408 23.768-2.322 5.974-5.096 10.239-9.575 14.718-4.479 4.479-8.743 7.253-14.717 9.574-4.511 1.753-11.289 3.839-23.769 4.408-13.495.616-17.543.746-51.722.746-34.18 0-38.228-.13-51.723-.746-12.48-.57-19.257-2.655-23.768-4.408-5.974-2.321-10.239-5.095-14.718-9.574-4.479-4.48-7.253-8.744-9.574-14.718-1.753-4.51-3.839-11.288-4.408-23.768-.616-13.497-.746-17.545-.746-51.723 0-34.177.13-38.225.746-51.722.57-12.48 2.655-19.258 4.408-23.769 2.321-5.974 5.095-10.238 9.574-14.717 4.48-4.48 8.744-7.253 14.718-9.575 4.51-1.753 11.288-3.838 23.768-4.408 13.497-.615 17.545-.745 51.723-.745M128 0C93.237 0 88.878.147 75.226.77c-13.625.622-22.93 2.786-31.071 5.95-8.418 3.271-15.556 7.648-22.672 14.764C14.367 28.6 9.991 35.738 6.72 44.155 3.555 52.297 1.392 61.602.77 75.226.147 88.878 0 93.237 0 128c0 34.763.147 39.122.77 52.774.622 13.625 2.785 22.93 5.95 31.071 3.27 8.417 7.647 15.556 14.763 22.672 7.116 7.116 14.254 11.492 22.672 14.763 8.142 3.165 17.446 5.328 31.07 5.95 13.653.623 18.012.77 52.775.77s39.122-.147 52.774-.77c13.624-.622 22.929-2.785 31.07-5.95 8.418-3.27 15.556-7.647 22.672-14.763 7.116-7.116 11.493-14.254 14.764-22.672 3.164-8.142 5.328-17.446 5.95-31.07.623-13.653.77-18.012.77-52.775s-.147-39.122-.77-52.774c-.622-13.624-2.786-22.929-5.95-31.07-3.271-8.418-7.648-15.556-14.764-22.672C227.4 14.368 220.262 9.99 211.845 6.72c-8.142-3.164-17.447-5.328-31.071-5.95C167.122.147 162.763 0 128 0Zm0 62.27C91.698 62.27 62.27 91.7 62.27 128c0 36.302 29.428 65.73 65.73 65.73 36.301 0 65.73-29.428 65.73-65.73 0-36.301-29.429-65.73-65.73-65.73Zm0 108.397c-23.564 0-42.667-19.103-42.667-42.667S104.436 85.333 128 85.333s42.667 19.103 42.667 42.667-19.103 42.667-42.667 42.667Zm83.686-110.994c0 8.484-6.876 15.36-15.36 15.36-8.483 0-15.36-6.876-15.36-15.36 0-8.483 6.877-15.36 15.36-15.36 8.484 0 15.36 6.877 15.36 15.36Z" />
        </svg>
    )
}

export function Twitter(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 400 400"
            style={{
                enableBackground: 'new 0 0 400 400',
            }}
            xmlSpace="preserve"
            {...props}
        >
            <path d="M125.7 362.6c150.9 0 233.5-125.1 233.5-233.5 0-3.5 0-7-.2-10.6 16-11.5 30-26 41-42.5-14.7 6.6-30.6 10.9-47.2 13 17-10.1 29.9-26.2 36.2-45.4-15.8 9.4-33.4 16.2-52.2 19.8-15-16-36.3-25.9-59.8-25.9-45.3 0-82.1 36.8-82.1 82.1 0 6.4.8 12.6 2.1 18.7-68.2-3.4-128.7-36.2-169.1-85.8-7 12.2-11 26.2-11 41.3 0 28.5 14.6 53.6 36.5 68.3-13.4-.5-26.1-4.2-37.1-10.2v1.1c0 39.7 28.3 73 65.8 80.5-6.9 1.9-14.1 2.9-21.6 2.9-5.3 0-10.4-.5-15.4-1.4 10.4 32.6 40.8 56.3 76.7 57-28.4 21.9-63.8 35.1-102.2 35.1-6.6 0-13.1-.3-19.5-1.1 36.2 23 79.4 36.6 125.6 36.6" />
        </svg>
    )
}
